export const DEFAULT_ONFLEET_STORE_DETAIL = {
  of_api_key: '',
  of_webhooks_secret: '',
}
